import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { VisitationDetailDto } from '@api/models/visitations/VisitationDetailDto';
import { visitationService } from '@api/services/services';

type State = BaseType<VisitationDetailDto>;

const initialState: State = {
  state: FetchState.None,
  data: {},
};

export const visitationSlice = baseSlice({
  name: 'visitation',
  initialState,
});

export const selectVisitationState = (state: RootState) => state.visitation.state;
export const selectVisitation = (state: RootState) => state.visitation.data;
export const visitationActions = visitationSlice.actions;

export const getVisitation = (visitationId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return visitationService.getVisitation(visitationId);
  };

  getItem({
    dispatch,
    actions: visitationActions,
    getData: handleGetData,
  });
};
